import modal from "@components/Modal.vue";
import embeddedVideo from "@public-client/Components/Video.vue";
import NavItem from "@public-client/Components/NavItem.vue";
import { smoothAfterEnter, smoothEnter, smoothLeave } from "@public-client/router";
export default {
  components: {
    NavItem,
    modal,
    embeddedVideo
  },
  data() {
    return {
      transitionName: "slide-left",
      enableVideo: false,
      cycleId: 4
    };
  },
  mounted() {
    this.$refs.routerView.$el.style.opacity = 0;
    this.$store.dispatch("trackScrollPosition");
    this.$store.dispatch("load").then(() => {
      this.$refs.routerView.$el.style.opacity = 1;
    });
  },
  computed: {
    loading() {
      return this.$store.state.loading || this.$store.state.activeRequests.length != 0;
    },
    cycle() {
      let target = this.$store.getters.cycle;
      return target ? target : {};
    },
    cycleOptions() {
      return this.$store.state.cycles;
    },
    selectedCycle() {
      return this.$store.state.cycleId;
    },
    showVideoModal() {
      return this.$store.state.showVideoModal;
    }
  },
  watch: {
    $route(to, from) {
      let toParts = to.path + "";
      if (toParts.startsWith("/")) {
        toParts = toParts.substr(1, toParts.length - 1);
        toParts = toParts.split("/");
      }
      let fromParts = from.path + "";
      if (fromParts.startsWith("/")) {
        fromParts = fromParts.substr(1, fromParts.length - 1);
        fromParts = fromParts.split("/");
      }
      this.transitionName = toParts.length < fromParts.length ? "slide-right" : "slide-left";
    },
    showVideoModal(val) {
      if (val) this.$refs.videoModal.open();else this.$refs.videoModal.close();
    },
    selectedCycle(val) {
      this.cycleId = val;
    },
    "$store.state.cycleId"(curr, prev) {
      if (curr != null && prev != null && !this.$store.state.loading) this.loadCycleData();
    }
  },
  methods: {
    leave: smoothLeave,
    enter: smoothEnter,
    afterEnter: smoothAfterEnter,
    enterCancelled: smoothAfterEnter,
    hideVideo() {
      this.$store.dispatch("openVideoModal", false);
    },
    changeCycle() {
      this.$store.dispatch("setCycleId", this.cycleId);
    },
    loadCycleData() {
      this.$store.dispatch("loadCycleData", this.$store.state.cycleId);
    }
  }
};